export default __webpack_public_path__ + "static/media/Beauty_of_bhopal.a0b09986.jpg";